export default __webpack_public_path__ + "static/media/pic5.222ca65b.jpg";